import { PageTemplate } from '@/components/templates'
import { CONTAINER_SIZES } from '@/constants'
import { 
  PartnershipsHeader, 
  KeyBenefitsSection, 
  PartnerTypesSection, 
  ApiFeaturesSection, 
  ContactSection 
} from '@/components/partnerships'

const PartnershipsScreen = () => {
  return (
    <PageTemplate
      title="Partnerships"
      subtitle="Join the SecondLane Liquidity Highway"
      maxWidth={CONTAINER_SIZES.WIDE}
    >
      <div className="space-y-6">
        {/* Header */}
        <PartnershipsHeader />
        
        {/* Key Benefits */}
        <KeyBenefitsSection />
        
        {/* Partner Types */}
        <PartnerTypesSection />
        
        {/* API Features */}
        <ApiFeaturesSection />
        
        {/* Contact Section */}
        <ContactSection />
      </div>
    </PageTemplate>
  )
}

export default PartnershipsScreen 